module.exports = __webpack_public_path__ + "media/bootstrap-icons/globe-d785106e.svg";